// src/pages/Appli/AppliAdmin/users-admin/components/UsersHeader.jsx

import React from "react";

import {
  FaBuilding,
  FaIdBadge,
  FaUser,
  FaUsers,
} from "react-icons/fa";

import StatCard from "../ui/StatCard";

export default function UsersHeader({
  totalUsers,
  totalBadges,
  totalClubs,
  totalActeurs,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Administration
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              Gestion des utilisateurs
            </h1>

            <p className="mt-2 max-w-3xl text-sm text-slate-600 dark:text-slate-300">
              Gestion des comptes, des rôles, des clubs, des acteurs et des
              badges associés.
            </p>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 xl:min-w-[760px] xl:grid-cols-4">
            <StatCard
              icon={<FaUser />}
              label="Utilisateurs"
              value={totalUsers}
              accent="indigo"
            />

            <StatCard
              icon={<FaUsers />}
              label="Acteurs liés"
              value={totalActeurs}
              accent="cyan"
            />

            <StatCard
              icon={<FaBuilding />}
              label="Clubs liés"
              value={totalClubs}
              accent="amber"
            />

            <StatCard
              icon={<FaIdBadge />}
              label="Badges"
              value={totalBadges}
              accent="emerald"
            />
          </div>
        </div>
      </div>
    </div>
  );
}